import { useState } from "react";
import { ChevronDown, Pencil, Plus, Tractor, Upload } from "lucide-react";
import { useUiStore } from "../../stores/uiStore";
import { Menu, MenuItem } from "../../ui/Menu";

// dropdown is what let the whole toolbar move up into the global header without crowding it; the
// three choices are unchanged, and each still opens exactly what it opened before. Closes on
// outside click and on Escape, like the profile menu — a menu that only closes by re-clicking its
// own trigger is a menu you have to fight.
const ITEMS = [
  {
    key: "draw",
    icon: Pencil,
    label: "Draw boundary",
    hint: "Trace a field on the map",
  },
  {
    key: "jd",
    icon: Tractor,
    label: "Pull from JD Ops",
    hint: "Pick one or many John Deere fields",
  },
  {
    key: "upload",
    icon: Upload,
    label: "Single/Bulk Upload",
    hint: "Boundaries, zones, samples, EC scans — any mix",
  },
] as const;

export function AddFieldMenu() {
  const openNewField = useUiStore((s) => s.openNewField);
  const openBulkDump = useUiStore((s) => s.openBulkDump);
  const [open, setOpen] = useState(false);

  const pick = (key: (typeof ITEMS)[number]["key"]) => {
    setOpen(false);
    if (key === "draw") openNewField("draw");
    else openBulkDump(key);
  };

  return (
    <Menu
      open={open}
      onOpenChange={setOpen}
      trigger={
        <button
          type="button"
          className="flex items-center gap-1.5 rounded px-2.5 py-1.5 text-[12px] text-muted hover:bg-hover hover:text-fg"
        >
          <Plus size={13} /> Add Field/Data
          <ChevronDown
            size={12}
            className={
              open ? "rotate-180 transition-transform" : "transition-transform"
            }
          />
        </button>
      }
    >
      {ITEMS.map((it) => (
        <MenuItem key={it.key} onSelect={() => pick(it.key)}>
          <it.icon size={13} className="mt-0.5 shrink-0" />
          <span className="min-w-0">
            <span className="block font-medium text-fg">{it.label}</span>
            <span className="block text-[10px] text-faint">{it.hint}</span>
          </span>
        </MenuItem>
      ))}
    </Menu>
  );
}
